export const SITE_URL = 'https://www.gograbjob.com';

export interface BreadcrumbItem {
  name: string;
  /** Omit on the current page (last crumb). */
  path?: string;
}

/** BreadcrumbList schema for blog posts, pricing, and legal pages (W2.4). */
export function buildBreadcrumbJsonLd(
  items: BreadcrumbItem[],
): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      ...(item.path ? { item: `${SITE_URL}${item.path}` } : {}),
    })),
  };
}
